import { createStorageHooks } from './shared/storage';

const { useStorageValue: useSessionStorageValue, useStorageValueAsync: useSessionStorageValueAsync } =
	createStorageHooks(typeof sessionStorage === 'undefined' ? undefined : sessionStorage);

export { useSessionStorageValue, useSessionStorageValueAsync };
